'use client';

import { useTheme } from 'next-themes';
import { usePathname } from 'next/navigation';
import DriftEarnPage from 'src/components/Earn/DriftEarnPage';
import NavFooterLayout from 'src/components/Layouts/NavFooterLayout';
import { DriftTheme } from 'src/environmentVariables/EnvironmentVariableTypes';

export function EarnLayout({ children }: { children: React.ReactNode }) {
	const theme = useTheme().theme;
	const isDarkMode = theme === DriftTheme.dark;
	const pathname = usePathname();

	const isAmplifyPairPage =
		pathname?.includes('/earn/amplify/') && pathname !== '/earn/amplify';

	return (
		<NavFooterLayout
			overflowAuto
			middleClassName="bg-main-bg"
			pageBackground={!isDarkMode ? 'var(--color-container-bg)' : undefined}
		>
			{isAmplifyPairPage ? children : <DriftEarnPage>{children}</DriftEarnPage>}
		</NavFooterLayout>
	);
}
